import { invokeRPC } from './socket.js'

export function runAIChat(data) {
  return invokeRPC('aiTools', 'runAIChat', data, { ackTimeout: 240000 });
}

export function createChatId(customerId, userData, chatType) {
  return invokeRPC('aiTools', 'createChatId', { customer_id: customerId, userData: userData, chatType: chatType });
}

export function getChatInfo(data) {
  return invokeRPC('aiTools', 'getChatInfo', data);
}

export function getUsersChats(data) {
  return invokeRPC('aiTools', 'getUsersChats', data);
}

export function getUserChatHistory(data) {
  return invokeRPC('aiTools', 'getUserChatHistory', { chatId: data.chatId });
}

export function cancelAIStream(chatId) {
  return invokeRPC('aiTools', 'cancelAIStream', { chatId: String(chatId) });
}

export function getCustomersWithGlobalProject(data) {
  return invokeRPC('aiTools', 'getCustomersWithGlobalProject', data);
}

export function getCustomersWithSandboxProject(data) {
  return invokeRPC('aiTools', 'getCustomersWithSandboxProject', data);
}

export function getDashboardHtml(data) {
  return invokeRPC('aiTools', 'getDashboardHtml', { gcsPath: data.gcsPath });
}

export function getChatDisplayTitles(data) {
  return invokeRPC('aiTools', 'getChatDisplayTitles', { userId: data.userId });
}

export function editChatDisplayTitle(data) {
  return invokeRPC('aiTools', 'editChatDisplayTitle', { userId: data.userId, chatId: data.chatId, newTitle: data.newTitle });
}

export function getSharedChats(data) {
  return invokeRPC('aiTools', 'getSharedChats', { userData: data.userData, insightsType: data.insightsType });
}

export function getSharableUsers(data) {
  return invokeRPC('aiTools', 'getSharableUsers', { customerId: data.customerId, insightsType: data.insightsType });
}

export function getAlreadySharedUsers(data) {
  return invokeRPC('aiTools', 'getAlreadySharedUsers', { chatId: data.chatId });
}

export function shareChat(data) {
  return invokeRPC('aiTools', 'shareChat', { chatId: data.chatId, usersToShareTo: data.usersToShareTo, chatTitle: data.chatTitle });
}

export function saveUserAsset(data) {
  return invokeRPC('aiTools', 'saveUserAsset', data);
}

export function getUserDashboards(data) {
  return invokeRPC('aiTools', 'getUserDashboards', data);
}

export function getCustomerDashboards(data) {
  return invokeRPC('aiTools', 'getCustomerDashboards', data);
}

export function updateDashboardName(data) {
  return invokeRPC('aiTools', 'updateDashboardName', data);
}

export function getDashboardInfo(data) {
  return invokeRPC('aiTools', 'getDashboardInfo', data);
}

export function deleteDashboard(data) {
  return invokeRPC('aiTools', 'deleteDashboard', data);
}

export function deleteChat(data) {
  return invokeRPC('aiTools', 'deleteChat', data);
}

export function updateDashboardPreview(data) {
  return invokeRPC('aiTools', 'updateDashboardPreview', data);
}

export function updateDashboardOrder(data) {
  return invokeRPC('aiTools', 'updateDashboardOrder', data);
}

export function getImageExport(data) {
  return invokeRPC('aiTools', 'getImageExport', data);
}

export function getSecureDashboardUrl(data) {
  return invokeRPC('aiTools', 'getSecureDashboardUrl', data);
}

export function getSecureDashboardUrlFromId(data) {
  return invokeRPC('aiTools', 'getSecureDashboardUrlFromId', data);
}

export function getChatSuggestions(data) {
  return invokeRPC('aiTools', 'getChatSuggestions', data)
}

export function exportChatPdf(data) {
  return invokeRPC('aiTools', 'exportChatPdf', data)
}